export default __webpack_public_path__ + "static/media/GigLinked_Beta-Wave.b5f1325e.svg";